<template>
  <v-card>
    <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.smAndDown">
      <v-toolbar-title>{{ $t('rc-text-1') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn light icon @click="progress >= 4 ? cancelDialog = true : $emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
    <v-container class="pb-0" v-if="$vuetify.breakpoint.mdAndUp">
      <v-row justify="end">
        <v-col class="shrink">
          <v-btn color="color-grey" depressed right text small @click="progress >= 4 ? cancelDialog = true : $emit('close')">
            <v-icon class="mr-3">fa-times</v-icon>
            <span>{{ $t('close') }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row justify="center">
        <div class="pa-3">
          <v-icon :size="175" color="success">
            far fa-check-circle
          </v-icon>
        </div>
      </v-row>
      <v-row v-if="$vuetify.breakpoint.mdAndUp">
        <v-col cols="12">
          <h3 class="mt-4 mt-3 text-h3 text-center">{{ $t('rc-text-1') }}</h3>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="9">
          <p>{{ $t('rc-text-3') }}</p>
          <p v-html="$t('rc-text-4')" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="10">
          <v-card outlined>
            <v-container class="pa-6">
              <v-row align="center">
                <v-col class="shrink">
                  <v-icon>fas fa-info-circle</v-icon>
                </v-col>
                <v-col>
                  <span>{{ $t('rc-text-5') }}</span>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p class="font-weight-bold text-center">{{ $t('rc-text-6') }}</p>
        </v-col>
      </v-row>
      <v-row justify="center" class="text-center">
        <shared-customer-feedback :orderNr="debtNr" :type="7" @close="$emit('close')"></shared-customer-feedback>
      </v-row>
      <v-row justify="center">
        <div class="pa-3">
          <v-btn tile outlined color="color-new-link-blue" class="wide-button" @click="$emit('close')">
            <span>{{ $t('close') }}</span>
          </v-btn>
        </div>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    computed: {
      paymentPlan() {
        return this.$store.getters.latestPaymentPlan
      },
      debtNr() {
        if (this.paymentPlan !== null) {
          return this.paymentPlan.debts[0].nr
        } else {
          return null
        }
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "rc-text-1": "Sovinto on tehty",
  "rc-text-2": "Lataa maksusuunnitelman tiedot (pdf)",
  "rc-text-3": "B2 Impact toimittaa sovintosopimuksen käräjäoikeuteen hyväksyttäväksi.",
  "rc-text-4": "Emme lähetä sovintosopimusta sinulle erikseen postitse. Sovinnon ja  sen maksusuunnitelman tiedot löytyvät jatkossa <b>\"Velan tiedot\"</b> -välilehdeltä.",
  "rc-text-5": "Tarkista, että yhteystietosi ovat ajantasalla. Lähetämme tekstiviestitse muistutuksen, kun sinun on aika maksaa seuraava maksusuunnitelman erä.",
  "rc-text-6": "Jotta sovinto pysyy voimassa, sinun tulee noudattaa maksusuunnitelman aikataulua."
  },
  "se": {
  "rc-text-1": "Förlikningsavtalet gjort",
  "rc-text-2": "Ladda ner betalningsplanens uppgifter (pdf)",
  "rc-text-3": "B2 Impact skickar förlikningsavtalet till tingsrätten för stadfästande.",
  "rc-text-4": "Förlikningsavtalet skickas inte till dig per post, utan du hittar informationen om avtalet samt betalningsplanen under rubriken <b>Skuldinformation</b>.",
  "rc-text-5": "Kontrollera att dina kontaktuppgifter är korrekta. Vi påminner dig per sms då det är dags att betala nästa rat.",
  "rc-text-6": "För att betalningsplanen ska hållas i kraft är det viktigt att du betalar raterna på de överenskomna förfallodatumen."
  },
  "en": {
  "rc-text-1": "Settlement completed",
  "rc-text-2": "Download payment plan details (pdf)",
  "rc-text-3": "B2 Impact will deliver the settlement agreement to the district court for confirmation.",
  "rc-text-4": "We will not send the agreement to you by mail. In the future, you can find the settlement information and payment plan details under the <b>\"Debt information\"</b> -tab.",
  "rc-text-5": "Please make sure that your contact information is up to date. We will send you a reminder via SMS message when the next installment is due.",
  "rc-text-6": "From now on, it is important that you strictly adhere to the agreed payment plan and due dates."
  }
  }
</i18n>
